import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { TelescopeIcon } from 'secondstep-components'

export const StyledContainer = styled.div`
  background-image: url(${props => props.bannerImage});
  background-repeat: no-repeat;
  background-color: #faf495;
  background-size: cover;
  height: 3.25rem;
  margin-bottom: 0;
  width: 100vw;
  padding-top: ${themeGet('spacing.turquoise20_1_25rem')};
  padding-bottom: ${themeGet('spacing.turquoise20_1_25rem')};
  top: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
`
export const StyledTelescopeIcon = styled(TelescopeIcon)`
  float: left;
  margin-top: ${themeGet('spacing.green4_0_25rem')};
  margin-right: ${themeGet('spacing.blue16_1rem')};
  rect {
    stroke: ${themeGet('colors.highSchool.green2')};
  }
  path {
    stroke: ${themeGet('colors.highSchool.green2')};
    fill: ${themeGet('colors.hsPrimaryPink')};
    fill-opacity: 0.3;
  }
  width: 47px;
  height: 33px;
  viewbox: 0 0 47 33;
`

export const StyledStrongText = styled.p`
  color: ${themeGet('colors.highschool.green2')};
  font-family: ${themeGet('font.molde.semiBold')};
  font-size: 18px;
  font-weight: 400;
  line-height: 20px;
`
